import RainReporting from "../../../views/RainReporting";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const RainReportingRoutes = [
  {
    menuName: MenuNames.GROUND_INTELLIGENCE,
    path: "/rain-reporting",
    component: RainReporting,
    exact: true,
  },
];

export default RainReportingRoutes;
